import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { ApiError } from 'api/core/ApiError';
import { DailyNavService } from 'api/services/DailyNavService';
import { UpdateDailyNavRecordParams } from './useUpdateDailyNavRecord.types';

// Leaves the records list alone; the caller refreshes just this row with useRefreshDailyNavRecord.
const useUpdateDailyNavRecord = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: ({ id, data }: UpdateDailyNavRecordParams) => DailyNavService.apiDailyNavPartialUpdate(id, data),
    onSuccess: () => {
      enqueueSnackbar('Daily NAV record updated.', { variant: 'success' });
    },
    onError: (error: unknown) => {
      let message = 'Failed to update Daily NAV record.';
      if (error instanceof ApiError && typeof error.body === 'object' && error.body) {
        const { detail } = error.body as Record<string, unknown>;
        if (typeof detail === 'string') {
          message = detail;
        }
      } else if (error instanceof Error && error.message) {
        message = error.message;
      }
      enqueueSnackbar(message, { variant: 'error' });
    },
  });
};

export default useUpdateDailyNavRecord;
